<p-toast></p-toast>
<app-nav-header></app-nav-header>
<div class="wrapper">
	<div class="main">
		<div id="recruitPage">
			<ng-container *ngIf="groupBreak">
				<div
					*ngIf="mode === 'list'"
					class="formArea"
				>
					<div class="formAreaBox">
						<div class="formBox">
							<div class="teamsBox">
								<div class="titleBox">
									<p>{{ groupBreak.mode === 'PYT' ? '選擇隊伍' : '選擇編號' }}</p>
									<span style="color: #f20c0c; font-weight: 700">
										多隊優惠：選購兩隊(含)以上，總金額優惠打9折
									</span>
									<br />
									<span
										*ngIf="groupBreak.mode === 'RDT'"
										style="color: #f20c0c; font-size: 2rem; font-weight: 700"
									>
										隨機隊伍 {{ groupBreak.perPrice }}/隊
									</span>
								</div>
								<div class="bodyBox">
									<ng-container *ngFor="let item of teamsList; let i = index">
										<span
											*ngIf="groupBreak.mode === 'PYT'"
											[ngClass]="!!item.isSelected ? 'selected-tag' : 'unselected-tag'"
											(click)="clickSelectTeams(item)"
										>
											{{ item.name }} -
											<del *ngIf="item.formerPrice">
												{{ item.formerPrice }}
											</del>
											{{ item.price }}
										</span>
										<span
											*ngIf="groupBreak.mode === 'RDT'"
											[ngClass]="!!item.isSelected ? 'selected-tag' : 'unselected-tag'"
											(click)="clickSelectTeams(item)"
										>
											{{ item.name }}
											<del *ngIf="item.formerPrice">
												{{ item.formerPrice }}
											</del>
										</span>
									</ng-container>
								</div>
							</div>
							<div class="personBox">
								<div class="titleBox">
									<p>個人資訊</p>
								</div>
								<form
									[formGroup]="buyerForm"
									class="row"
								>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span class="required">*</span>
											<span>收件姓名</span>
										</label>
										<div class="col pr-0 field-cus">
											<div class="d-flex">
												<input
													pInputText
													type="text"
													placeholder="請輸入收件姓名"
													formControlName="buyerName"
													id="buyerName"
												/>
											</div>
										</div>
									</div>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span>暱稱(選填)</span>
										</label>
										<div class="col pr-0 field-cus">
											<div class="d-flex">
												<input
													pInputText
													type="text"
													placeholder="請輸入暱稱(Excel表單用)"
													formControlName="buyerNickName"
													id="buyerNickName"
												/>
											</div>
										</div>
									</div>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span class="required hidden">*</span>
											<span>手機號碼</span>
										</label>
										<div class="col pr-0 field-cus">
											<input
												pInputText
												type="text"
												placeholder="請輸入手機號碼，ex: 0912345678"
												formControlName="buyerPhone"
												id="buyerPhone"
											/>
										</div>
									</div>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span class="required">*</span>
											<span>電子郵件</span>
										</label>
										<div class="col pr-0 field-cus">
											<input
												pInputText
												type="text"
												placeholder="請輸入電子郵件，ex: bigaunt@gmail.com"
												formControlName="buyerEmail"
												id="buyerEmail"
											/>
										</div>
									</div>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span class="required">*</span>
											<span>匯款帳號</span>
										</label>
										<div class="col pr-0 field-cus">
											<input
												pInputText
												type="text"
												placeholder="請輸入末5碼"
												formControlName="buyerBankAccount"
												id="buyerBankAccount"
											/>
										</div>
									</div>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span class="required">*</span>
											<span>711店鋪</span>
										</label>
										<div class="col pr-0 field-cus">
											<input
												pInputText
												type="text"
												placeholder="請輸入門市名稱"
												formControlName="711Name"
												id="711Name"
											/>
										</div>
									</div>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span>折扣代碼</span>
										</label>
										<div class="col pr-0 field-cus">
											<input
												*ngIf="!isDiscountCode"
												pInputText
												type="text"
												placeholder="請輸入折扣代碼(選填)"
												formControlName="discountCode"
												id="discountCode"
											/>
											<p-dropdown
												*ngIf="!!isDiscountCode"
												placeholder="請選擇折扣代碼"
												[filter]="true"
												appendTo="body"
												formControlName="discountCode"
												[emptyFilterMessage]="'查無符合的項目'"
												[options]="discountCodeOptions"
												[showClear]="true"
											></p-dropdown>
										</div>
									</div>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span>需空門卡</span>
										</label>
										<div class="col pr-0 field-cus">
											<p-dropdown
												placeholder="如未選擇視為不需要"
												[filter]="true"
												appendTo="body"
												formControlName="needEmptyCard"
												[emptyFilterMessage]="'查無符合的項目'"
												[options]="boolOptions"
												[showClear]="true"
											></p-dropdown>
										</div>
									</div>
									<div class="form-group d-flex col-12 align-items-center mb-3">
										<label class="mb-0">
											<span>球卡支架</span>
										</label>
										<div class="col pr-0 field-cus">
											<p-inputNumber
												formControlName="addDisplayCard"
												[showButtons]="true"
												buttonLayout="horizontal"
												inputId="horizontal"
												spinnerMode="horizontal"
												[step]="1"
												[min]="0"
												incrementButtonIcon="pi pi-plus"
												decrementButtonIcon="pi pi-minus"
											></p-inputNumber>
										</div>
									</div>
									<div
										(click)="op.toggle($event)"
										style="cursor: pointer; text-decoration: underline; padding-left: 1rem"
									>
										點擊查看支架尺寸(10元/個)
									</div>
								</form>
								<div style="flex: 2">
									<div class="footerBox">
										<button
											class="vacancies-btn"
											(click)="openDetailPage()"
										>
											<span>送出表單</span>
										</button>
									</div>
								</div>
								<div style="flex: 10; font-size: 1.4rem">
									<div>
										<img
											[src]="groupBreak.image"
											[alt]="groupBreak.title"
											style="border-radius: 1rem"
										/>
									</div>
									<br />
									{{ groupBreak.productId }}團拆卡盒：
									<br />
									{{ groupBreak.title }}
									<br />
									<ng-container *ngFor="let line of (groupBreak.description || '').split('\n')">
										{{ line }}
										<br />
									</ng-container>
									<span style="color: #f20c0c">訂購注意事項：</span>
									<br />
									<span style="color: #f20c0c">
										送出表單之後請在15分鐘內完成匯款，系統將會不定期上去清票。如在清票期間超過付款期限，所選隊伍將會自動釋出。
									</span>
									<br />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					*ngIf="mode === 'detail'"
					class="detailArea"
				>
					<div class="detailAreaBox">
						<div class="titleBox">
							<p>訂單明細</p>
						</div>
						<div class="detailBox">
							<p-dataView
								[value]="selectedTeamsList"
								layout="list"
								emptyMessage=""
							>
								<ng-template pTemplate="header">
									<div class="p-text-center p-p-3">
										<p style="color: #f20c0c">多隊優惠：</p>
										<p style="color: #f20c0c">選購兩隊以上，總金額優惠打9折</p>
										<div
											*ngIf="buyerForm.value.addDisplayCard > 0"
											style="
												display: flex;
												text-align: center;
												justify-content: space-around;
												width: 100%;
												background: #ffffff;
												border: solid #e9ecef;
												border-width: 0 0 1px 0;
											"
										>
											<span>
												{{ '支架數量：' + buyerForm.value.addDisplayCard }}
											</span>
											<span>{{ '$' + buyerForm.value.addDisplayCard * 10 }}</span>
										</div>
										<strong>{{ groupBreak.mode === 'PYT' ? '選擇隊伍：' : '選擇編號' }}</strong>
									</div>
								</ng-template>
								<ng-template
									*ngIf="selectedTeamsList.length > 0"
									let-team
									pTemplate="listItem"
								>
									<div class="detailRow">
										<div>
											{{ groupBreak.productId + '： ' + team.name }}
										</div>
										<div>{{ team.price }}</div>
									</div>
								</ng-template>
								<ng-template pTemplate="footer">
									<div
										class="p-text-center p-p-3"
										style="font-size: 1.5rem"
									>
										<strong>總金額:</strong>
										{{ '$' + calcTotalTeamsCost(selectedTeamsList) }}
										{{
											buyerForm.value.discountAmount
												? '(已折扣$' + buyerForm.value.discountAmount + ')'
												: ''
										}}
									</div>
								</ng-template>
							</p-dataView>
						</div>
						<div class="footerBox">
							<button
								class="vacancies-btn"
								(click)="confirmOrderDetail()"
							>
								<span>確認</span>
							</button>
						</div>
					</div>
				</div>

				<div
					*ngIf="mode === 'success'"
					class="detailArea"
					style="padding-top: 20vh !important"
				>
					<div class="detailAreaBox">
						<div class="titleBox">
							<p>訂購成功！！</p>
							<p>看到這個畫面即可進行匯款</p>
							<p>匯款資訊：(台新銀行)812-28881022569059</p>
							<p>{{ '總金額：$' + calcTotalTeamsCost(selectedTeamsList) }}</p>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
<app-footer *ngIf="mode !== 'success'"></app-footer>
<p-overlayPanel #op>
	<img
		src="/bigaunt/assets/images/display-card.png"
		alt="Big Aunt's"
		class="random-notice"
	/>
</p-overlayPanel>
